import React, { useState } from 'react';
import { useStyles } from '../../../../lib/styles';
import Typography from '../../../presentational/Typography';
import { months, constructNumberRange } from '../../../../../src/lib/dateUtilities';

import membershipSignupPanelStyles from './MembershipSignupPanel_styles';
import api from '../../../authenticate/Authenticate/api';
import Spacer from '../../Spacer';
import Button from '../../Button';
import Icon from '../../Icon';
import clsx from 'clsx';
import { isEmail } from '../../../../lib/validationUtils';
import { MEMBERCENTRE_UPDATE_CLICK, raiseEvent } from '../../../../lib/gtm';
import { compose, withProps, withState } from 'recompose';
import { cfImage, computeReferrer } from '../../../../lib/stringUtils';
import * as queryString from 'querystring';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import _ from 'lodash';
import theme from '../../../../lib/theme';
import { useSelector, useDispatch } from 'react-redux';
import { TrackingDataState } from '../../../../store/reducers/trackingData';
import { trackingDataSelector } from '../../../../store/selectors';
import { MembershipValidation } from '../../../../views/Collection/CollectionBlock/Blocks/MembershipBlock';
const { layoutWidths } = theme;

dayjs.extend(customParseFormat);

export interface MembershipSignupPanelProps {
  joinBackgroundImage: string;
  joinPersonImage: string;
  joinTitle: string;
  joinDescription: string;
  joinEmailTextboxPlaceholder: string;
  joinButtonText: string;
  joinConfirmationText: string;
  source: string | null;
  routingParams: {},
  isSaving: boolean;
  setIsSaving: (isSaving: boolean) => void;
  validation: MembershipValidation;
  setValidation: (validation: MembershipValidation) => void;
  setIsLoading: (isLoading: boolean) => void;
  onSignUp: (subscriberDetails: any) => void;
}

export const MembershipSignupPanel = (props: MembershipSignupPanelProps) => {
  const trackingSelectorData: TrackingDataState = useSelector(trackingDataSelector);
  const dispatch = useDispatch();

  const {
    joinPersonImage,
    joinTitle,
    joinDescription,
    joinEmailTextboxPlaceholder,
    joinButtonText,
    joinConfirmationText,
    source,
    routingParams,
    isSaving = false,
    setIsSaving,
    validation,
    setValidation,
    setIsLoading,
    onSignUp,
  } = props;
  
  const styles = useStyles(membershipSignupPanelStyles(props));

  const [userEmail, setUserEmail] = useState('');
  const [userEmailIsValid, setUserEmailIsValid] = useState(true);
  const [firstName, setFirstName] = useState<any>('');
  const [lastName, setLastName] = useState<any>('');
  const [dobDay, setDOBDay] = useState<string>('14');
  const [dobMonth, setDOBMonth] = useState<string>('');
  const [dobYear, setDOBYear] = useState<string>('1966');

  const validate = () => {
    //  validate fields
    if (!userEmail || !isEmail(userEmail)) {
      setUserEmailIsValid(false);
      setValidation({ isValid: false, message: 'Please enter a valid email address.' });
      return { isValid: false, message: 'Please enter your email address.' };
    }

    // if ((dobDay && dobMonth && dobYear)
    //   && !dayjs(`${dobYear}-${dobMonth.padStart(2, '0')}-${dobDay.padStart(2, '0')}`, 'YYYY-MM-DD', true).isValid()) {
    //   setValidation({ isValid: false, message: 'Oops. That DOB does not look right. Please try again.' });
    //   return { isValid: false, message: 'Oops. That DOB does not look right. Please try again.' };
    // }

    return { isValid: true, message: '' };
  };

  const submitJoinNow = (e) => {
    e.preventDefault();
    setIsSaving(true);
    setIsLoading(true);

    const { isValid, message } = validate();
    setValidation({ isValid, message });
    if (!isValid) {
      setIsSaving(false);
      setIsLoading(false);
      return;
    }

    const subscriberDetails = {
      source,
    };

    if (firstName) { subscriberDetails['given_names'] = firstName; }
    if (lastName) { subscriberDetails['last_name'] = lastName; }
    // if (dobDay && dobMonth && dobYear) {
    //   subscriberDetails['dob'] = `${dobYear}-${dobMonth.padStart(2, '0')}-${dobDay.padStart(2, '0')}`;
    // };
    if (trackingSelectorData.anonymous_uuid) {
      subscriberDetails['anonymous_uuid'] = trackingSelectorData.anonymous_uuid;
    }
    const dotDigitalDataFields: {[key: string]: string | null}[] = [
      {key: 'SOURCE', value: subscriberDetails.source},
    ];
    Object.keys(subscriberDetails).forEach((key) => {
      dotDigitalDataFields.push({
        key: key,
        value: subscriberDetails[key],
      });
    });

    setIsSaving(true);
    const collectedSubscriber = api.collectSubscriber(userEmail, subscriberDetails);
    return Promise.all([ collectedSubscriber, ])
      .then(([collectSubscriber]) => {
        setIsLoading(true);
        raiseEvent(MEMBERCENTRE_UPDATE_CLICK);
        return collectSubscriber;
      })
      .then((collectedSubscriber) => onSignUp({
        email: userEmail,
        ...collectedSubscriber,
      }))
      .then(() => {
        setIsSaving(false);
      })
      .catch(() => {
        setValidation({ isValid: false, message: 'Oops, there was a problem saving. Please try again later.' });
        setIsLoading(false);
        setIsSaving(false);
      });
  };

  return (
    <>
      <div className={`signupWrap ${styles.container}`}>
        {/* {submitSuccessful && (
          <Pixel given_names={firstName} last_name={lastName} email={userEmail} />
        )} */}

        <Spacer width={layoutWidths.contentPane} space={['m', 'l']}>
          <Typography className={`signUpContainer ${styles.signUpContainer}`}>
            <div className={`signupPicture ${styles.signupPicture}`}>
              <img src={cfImage(joinPersonImage, { width: 300 })} width={300} alt={joinTitle} title={joinTitle} />
            </div>
            <div className={`signupText ${styles.signupText}`}>
              <form
                className={clsx(`needs-validation`)}
                onSubmit={submitJoinNow}
                id="memberSignupForm"
                noValidate
                autoComplete='off'
              >
                <div className={`membership-form-container ${styles.section}`}>
                  <Spacer maxWidth={'100%'} space={'m'}>
                    <Typography>
                      <h2>
                        <strong>{joinTitle}</strong>
                      </h2>
                      <p>{joinDescription}</p>
                      {!validation.isValid && (
                        <>
                          <div className={`formGroupContainer ${styles.formGroupContainer}`}>
                            <div className={`formGroup ${styles.formGroup}`}>
                              <label
                                className="control-label"
                                htmlFor="profile-field-email"
                              >
                                Email <span style={{ color: 'red' }}>*</span>
                              </label>
                              <input
                                className={clsx(`form-control`, { 'is-invalid': !userEmailIsValid })}
                                id={`profile-field-email`}
                                type="text"
                                required
                                value={userEmail}
                                autoFocus
                                onChange={e => {
                                  const email = e.target.value;
                                  setUserEmail(email);
                                  setUserEmailIsValid(isEmail(email) && email != '');
                                }}
                              />
                            </div>
                            <div className={`formGroup ${styles.formGroup}`}>
                              <label
                                className="control-label"
                                htmlFor="profile-field-firstname"
                              >
                                First Name
                              </label>
                              <input
                                className={`form-control`}
                                id={`profile-field-firstname`}
                                type="text"
                                value={firstName}
                                onChange={e => setFirstName(e.target.value)}
                              />
                            </div>
                            <div className={`formGroup ${styles.formGroup}`}>
                              <label
                                className="control-label"
                                htmlFor="profile-field-lastname"
                              >
                                Last Name
                              </label>
                              <input
                                className={`form-control`}
                                id={`profile-field-lastname`}
                                type="text"
                                value={lastName}
                                onChange={e => setLastName(e.target.value)}
                              />
                            </div>
                            {/* <div className={`formGroup ${styles.formGroup} ${styles.dobGroup}`}>
                              <label
                                className="control-label"
                                htmlFor="profile-field-dob"
                              >
                                Date of Birth{' '}
                              </label>
                              <Spacer
                                row
                                selfH={0}
                                width={`100%`}
                                className={`${styles.dobContainer}`}
                              >
                                <select
                                  className={`form-control pr-2`}
                                  value={dobDay}
                                  onChange={e => setDOBDay(e.target.value)}
                                >
                                  {Array.from({length: 31}, (_, i) => i + 1).map(key => (
                                    <option key={key} value={key}>
                                      {key}
                                    </option>
                                  ))}
                                </select>
                                <select
                                  className={`form-control pr-2`}
                                  value={dobMonth}
                                  onChange={e => setDOBMonth(e.target.value)}
                                >
                                  <option value="">Month</option>
                                  {months.map((month, key) => (
                                    <option key={key} value={month.index}>
                                      {month.full}
                                    </option>
                                  ))}
                                </select>
                                <select
                                  className={`form-control pr-2`}
                                  value={dobYear}
                                  onChange={e => setDOBYear(e.target.value)}
                                >
                                  {constructNumberRange(
                                    1930,
                                    parseInt(
                                      dayjs()
                                        .add(dayjs.duration({ years: -15 }))
                                        .format('YYYY')
                                    )
                                  )
                                    .reverse()
                                    .map((year, key) => (
                                      <option key={key} value={year}>
                                        {year}
                                      </option>
                                    ))}
                                </select>
                              </Spacer>
                            </div> */}
                          </div>
                          <div
                            className={
                              `membership-form-controls-container justify-content-start
                              ${styles.controlsContainer}`}
                          >
                            {isSaving && (
                              <Button disabled={true} onClick={() => {}}>
                                <Icon icon={'autorenew'} rotateIcon={true} className={'mr-2'} />
                                <span>Please wait...</span>
                              </Button>
                            )}
                            {!isSaving && (
                              <Button
                                type={'submit'}
                                onClick={() => {}}
                              >
                                <span>
                                  {joinButtonText}
                                </span>
                              </Button>
                            )}
                          </div>
                        </>
                      )}
                      </Typography>

                    {validation.isValid === true && (
                      <div
                        className={`alert alert-success text-center ${styles.alert}`}
                        role="alert"
                      >
                        {validation.message}
                        {_.has(routingParams, 'returnUrl') && (
                          <Button
                            className={`mx-auto mt-2`}
                            onClick={() => {
                              window.location.href = routingParams['returnUrl']?.toString() ?? '/';
                            }}
                          >
                            {routingParams['returnText']}
                          </Button>
                        )}
                      </div>
                    )}

                    {validation.isValid === false && (
                      <div
                        className={`alert alert-danger text-center ${styles.alert}`}
                        role="alert"
                      >
                        {validation.message}
                      </div>
                    )}
                  </Spacer>
                </div>
              </form>
            </div>
          </Typography>
        </Spacer>
      </div>
    </>
  );
};

export default compose(
  withState('source', 'setSource', 'website'),
  withProps(({ setSource }) => ({
    onMount: () => {
      setSource(computeReferrer());
    },
  })),
  withState('routingParams', 'setRoutingParams', () => queryString.parse(window.location.search.replace('?', ''))),
)(MembershipSignupPanel);